import { routesUrl } from "@/routes";
import { queryParamsStr } from "../index";


/** 跳转到RUCAM问卷 */
export function toRucam(params) {
    uni.navigateTo({
        url: routesUrl.rucam + queryParamsStr(params)
    })
}


/** 跳转到MV问卷 */
export function toMV(params) {
    uni.navigateTo({
        url: routesUrl.MV + queryParamsStr(params)
    })
}

/** 跳转到RUCAM答题历史 */
export function toRucamList(patient_id) {
    uni.navigateTo({
        url: routesUrl.rucamList + '?patient_id=' + patient_id || ''
    })
}

/** 跳转到M&V历史 */
export function toMvList(patient_id) {
    uni.navigateTo({
        url: routesUrl.mvList + '?patient_id=' + patient_id || ''
    })
}